import {
  IEditPerson,
  IInputGeofencePerson,
  IParamsPerson,
  IPerson,
  IPersonDetail,
  IReponsePersonHealthStats,
  IResponseGetPersonDetail,
  IResponseGetPerson,
} from '~/utils/interface/person';
import axiosClient from './axiosClient';

const url: string = '/api/persons';

const personApi = {
  getList(params: IParamsPerson, config?: { signal?: AbortSignal }) {
    return axiosClient.get<IResponseGetPerson>(url, {
      params,
      signal: config?.signal,
    });
  },

  export(params: IParamsPerson) {
    return axiosClient.get(`${url}/export`, {
      params
    });
  },

  getPerson(id: string) {
    return axiosClient.get<IResponseGetPersonDetail>(`${url}/${id}`);
  },

  getPersonDetail(id: string) {
    return axiosClient.get<IPersonDetail>(`${url}/person-detail/${id}`);
  },

  getHealthStats(id: string, params: IParamsPerson) {
    return axiosClient.get<IReponsePersonHealthStats>(`${url}/health-stats/${id}`, { params });
  },

  create(data: IEditPerson) {
    return axiosClient.post<IPerson>(url, data);
  },

  update(id: string, data: IEditPerson) {
    return axiosClient.put<IEditPerson>(`${url}/${id}`, data);
  },

  active(id: string, active: number) {
    return axiosClient.post<IEditPerson>(`${url}/active/${id}?active=${active}`);
  },

  delete(id: string) {
    return axiosClient.delete<IEditPerson>(`${url}/${id}`);
  },

  assignDevice(personId: number, data: { imei: string }) {
    return axiosClient.put(`${url}/assign-device/${personId}`, data);
  },

  changeDevice(personId: number, data: { imei: string; reason: string }) {
    return axiosClient.post(`${url}/change-device/${personId}`, data);
  },

  unassignDevice(personId: number, data: { reason: string }) {
    return axiosClient.post(`${url}/unassign-device/${personId}`, { reason: data.reason });
  },

  assignGeofence(data: IInputGeofencePerson) {
    return axiosClient.post(`${url}/assign-geofence`, data);
  },

  unassignGeofence(data: IInputGeofencePerson) {
    return axiosClient.post(`${url}/unassign-geofence`, data);
  },

  sendMessage(personId: string, data: { message: string }) {
    return axiosClient.post(`${url}/send-message/${personId}`, data);
  },

  sendMessageAll(username: string, data: { message: string }) {
    return axiosClient.post(`${url}/send-message-all?username=${username}`, data);
  },

  getMessages(personId: string | number, pageIndex = 1, pageSize = 10) {
    return axiosClient.get(`${url}/messages-person/${personId}?pageIndex=${pageIndex}&pageSize=${pageSize}`);
  },
};

export default personApi;
